import EditProduct from './EditProduct'

export default EditProduct



// WEBPACK FOOTER //
// ./src/components/Products/Edit/index.js